module.exports = __webpack_public_path__ + "src/assets/img/rigid_truck.4a02fdaf.svg";